export default __webpack_public_path__ + "static/media/SamplePDF.ae7dcb26.pdf";